var _path, _path2, _path3, _path4, _rect, _rect2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatte(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7223 60L19.6098 55H36.3902L42.2777 60L13.7223 60Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3735 15H41.6265C42.2466 15 42.7172 15.5585 42.6121 16.1696L35.9315 55H20.0685L13.3879 16.1696C13.2828 15.5585 13.7534 15 14.3735 15Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8718 7.84539L22.3012 7.71877L22.4928 7.31418C23.4037 5.39034 25.5047 4 28 4C30.4953 4 32.5963 5.39034 33.5072 7.31418L33.6988 7.71877L34.1282 7.84539C36.2759 8.47867 38.0254 9.4197 39.2193 10.5162C40.4102 11.6101 41 12.8067 41 14C41 14.3368 40.9536 14.6704 40.8617 15H15.1383C15.0464 14.6704 15 14.3368 15 14C15 12.8067 15.5897 11.6101 16.7807 10.5162C17.9746 9.4197 19.7241 8.47867 21.8718 7.84539Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1793 44L40.3331 31H45.4425C49.0323 31 51.9425 33.9101 51.9425 37.5C51.9425 41.0899 49.0323 44 45.4425 44H38.1793Z",
    stroke: "white",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 25.5,
    width: 25,
    height: 1,
    fill: "#D9D9D9",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 43.5,
    width: 19,
    height: 1,
    fill: "#D9D9D9",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 12,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 8,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 11,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatte);
export default __webpack_public_path__ + "static/media/latte.14659ea7c8a79a89bb5de85b2ad5ab8a.svg";
export { ForwardRef as ReactComponent };